import { createSlice } from "@reduxjs/toolkit";
import { getOrdersService } from "../services/orders_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,

  ordersList: [],
  metaOrders: null,
};

const slice = createSlice({
  name: "orders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Using builder callback notation
    builder
      .addCase(getOrdersService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ordersList = action.payload?.data?.data;
        state.metaOrders = action.payload.data.meta.meta;
      })
      .addCase(getOrdersService.rejected, (state) => {
        state.isLoading = false; // Corrected the property name
      })
      .addCase(getOrdersService.pending, (state) => {
        state.isLoading = true; // Corrected the property name
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
